import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AssistantPeriod {
  preset: 'today' | 'week' | 'month' | 'year' | 'all' | 'custom';
  timezone?: string;
  date_from?: string | null;
  date_to?: string | null;
}

export interface AssistantChatResponse {
  reply: string;
  sources: Array<Record<string, unknown>>;
  view_updates: {
    period?: AssistantPeriod;
    filters?: {
      ticket_opened?: number;
      ticket_closed?: number;
      idstatus?: number;
      idsubstatus?: number;
      incharge_user_id?: number;
    };
  } | null;
  table: {
    columns: string[];
    rows: Array<Record<string, unknown>>;
  } | null;
  chart: {
    type: string;
    series?: unknown[];
  } | null;
  model_used: string;
  pii_redacted: boolean;
}

export type AssistantPanelMode = 'closed' | 'compact' | 'expanded';

export interface AssistantChatBubble {
  role: 'user' | 'assistant';
  text: string;
  table?: AssistantChatResponse['table'];
}

export type AssistantViewUpdate = NonNullable<AssistantChatResponse['view_updates']>;

@Injectable({ providedIn: 'root' })
export class AssistantStore {
  mode: AssistantPanelMode = 'closed';
  messages: AssistantChatBubble[] = [];
  loading = false;
  error: string | null = null;
  lastSources: Array<Record<string, unknown>> = [];
  draft = '';
  period: AssistantPeriod = {
    preset: 'today',
    timezone: 'Europe/Rome',
  };
  language: 'it' | 'en' = 'it';
  width: number | null = null;
  height: number | null = null;
  /** Vero solo finché non si ricarica la pagina: il dock è uscito dalla barra. */
  shownFromHeader = false;

  private readonly viewUpdatesSubject = new Subject<AssistantViewUpdate>();
  private readonly headerDockSubject = new Subject<boolean>();
  readonly headerDock$ = this.headerDockSubject.asObservable();
  readonly viewUpdates = this.viewUpdatesSubject.asObservable();

  setContext(period: AssistantPeriod, language: 'it' | 'en'): void {
    this.period = period;
    this.language = language;
  }

  clearConversation(): void {
    this.mode = 'closed';
    this.messages = [];
    this.loading = false;
    this.error = null;
    this.lastSources = [];
    this.draft = '';
    this.width = null;
    this.height = null;
  }

  publishViewUpdate(update: AssistantViewUpdate): void {
    this.viewUpdatesSubject.next(update);
  }

  toggleHeaderDock(): void {
    this.shownFromHeader = !this.shownFromHeader;
    if (!this.shownFromHeader) {
      this.mode = 'closed';
    }
    this.headerDockSubject.next(this.shownFromHeader);
  }
}
